import { useLocale } from 'shared/hooks/useLocale';
import { LocaleStore } from 'schema/locale';

export function useStoreValue() {
  const locale = useLocale();
  return LocaleStore[locale];
}
